import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyController/CtrlSystemRoleReqs/CtrlSystemRoleReqs';

const failMsg = (result) => result?.response?.data?.message || result?.message || undefined;

function* getSystemRoles(action) {
    try {
        const result = yield call(req.getSystemRolesReq, action);
        if (result?.success === true) {
            yield put({
                type: types.CTRL_SYS_ROLE_LIST_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.CTRL_SYS_ROLE_LIST_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_SYS_ROLE_LIST_FAILURE, message: e?.message });
    }
}

function* getSystemRoleDetails(action) {
    try {
        const result = yield call(req.getSystemRoleDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_SYS_ROLE_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_SYS_ROLE_DETAILS_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_SYS_ROLE_DETAILS_FAILURE, message: e?.message });
    }
}

function* getPermissionCatalog(action) {
    try {
        const result = yield call(req.getPermissionCatalogReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_SYS_PERMISSION_CATALOG_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_SYS_PERMISSION_CATALOG_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_SYS_PERMISSION_CATALOG_FAILURE, message: e?.message });
    }
}

function* createSystemRole(action) {
    try {
        const result = yield call(req.createSystemRoleReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_SYS_ROLE_CREATE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_SYS_ROLE_CREATE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_SYS_ROLE_CREATE_FAILURE, message: e?.message });
    }
}

function* updateSystemRole(action) {
    try {
        const result = yield call(req.updateSystemRoleReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_SYS_ROLE_UPDATE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_SYS_ROLE_UPDATE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_SYS_ROLE_UPDATE_FAILURE, message: e?.message });
    }
}

function* setSystemRolePermissions(action) {
    try {
        const result = yield call(req.setSystemRolePermissionsReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_SYS_ROLE_SET_PERMISSIONS_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_SYS_ROLE_SET_PERMISSIONS_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_SYS_ROLE_SET_PERMISSIONS_FAILURE, message: e?.message });
    }
}

function* deactivateSystemRole(action) {
    try {
        const result = yield call(req.deactivateSystemRoleReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_SYS_ROLE_DEACTIVATE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_SYS_ROLE_DEACTIVATE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_SYS_ROLE_DEACTIVATE_FAILURE, message: e?.message });
    }
}

export default function* CtrlSystemRoleSaga() {
    yield takeLatest(types.CTRL_SYS_ROLE_LIST, getSystemRoles);
    yield takeLatest(types.CTRL_SYS_ROLE_DETAILS, getSystemRoleDetails);
    yield takeLatest(types.CTRL_SYS_PERMISSION_CATALOG, getPermissionCatalog);
    yield takeLatest(types.CTRL_SYS_ROLE_CREATE, createSystemRole);
    yield takeLatest(types.CTRL_SYS_ROLE_UPDATE, updateSystemRole);
    yield takeLatest(types.CTRL_SYS_ROLE_SET_PERMISSIONS, setSystemRolePermissions);
    yield takeLatest(types.CTRL_SYS_ROLE_DEACTIVATE, deactivateSystemRole);
}
